module.exports = __webpack_public_path__ + "static/media/logo_siaf.c00b1c66.png";